export interface OpenStatus {
  is_open: boolean;
  next_transition_at?: string | null;
}

export type DeliveryMethod = "delivery" | "takeaway" | "dine_in";

export const DELIVERY_METHOD_TYPE: Record<DeliveryMethod, number> = {
  delivery: 1,
  takeaway: 2,
  dine_in: 3,
};

export interface ScheduleInterval {
  opening_day: string;
  opening_time: string;
  closing_day: string;
  closing_time: string;
}

export interface Venue {
  seller_id: string;
  name: string;
  description?: string | null;
  image_url?: string | null;
  banner_url?: string | null;
  address: string;
  latitude: number | null;
  longitude: number | null;
  channel_id: string;
  token: string;
  slug: string;
  channel_type: string;
  is_alive: boolean;
  is_online: boolean;
  is_temporarily_offline: boolean;
  delivery_methods: DeliveryMethod[];
  open_status: OpenStatus;
  schedule: ScheduleInterval[];
  today: ScheduleInterval[];
  distance_meters?: number | null;
  eta_minutes?: number | null;
  delivery_fee?: number | null;
  can_deliver_to_location?: boolean | null;
  currency?: string | null;
  company_name?: string | null;
  bic?: string | null;
  phone?: string | null;
  email?: string | null;
  guest_info_level: "name_only" | "name_and_phone" | null;
  banner?: Banner | null;
}

export interface Banner {
  enabled: boolean;
  title: string;
  subtitle?: string | null;
  cta_text?: string | null;
  cta_link?: string | null;
  background_color: string;
}

export interface MerchantResponse {
  slug: string;
  name: string;
  available_types: string[];
  venues: Venue[];
}
